import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';

import App from './js/App';
import { hotjar } from 'react-hotjar';
import { authService } from './js/apis/AuthService';

const url = new URL(window.location.href);
const code = url.searchParams.get('code');
const channelId = url.searchParams.get('channelId');
if (code) {
  authService.resetSession();
  sessionStorage.setItem('code', code);
}
if (channelId) {
  sessionStorage.setItem('channelId', channelId);
}

//Using react hotjar to set up hotjar analysis
if (
  process.env.REACT_APP_HOTJAR_SITE_ID &&
  process.env.REACT_APP_HOTJAR_VERSION
) {
  hotjar.initialize(
    process.env.REACT_APP_HOTJAR_SITE_ID,
    process.env.REACT_APP_HOTJAR_VERSION
  );
}

ReactDOM.render(<App />, document.getElementById('root'));
